import React, { useEffect, useState } from "react";
import {
  Airplay,
  ChevronLeft,
  Eye,
  Feather,
  Menu,
  Play,
  Target,
} from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";

import { useToast } from "../Components/toast/ToastProvider";
import Sidebar from "./Sidebar";
import Modal from "../Components/Modal";
import WagonForm from "../Components/WagonForm";

import {
  getAllWagons,
  saveWagon,
  updateWagon,
  deleteWagon,
} from "../Service/WagonService";

const Wagon = ({ handleLogout }) => {
  const [showSideBar, setShowSideBar] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [wagonData, setWagonData] = useState([]);

  const [wagonForm, setWagonForm] = useState({
    date: "",
    station: "",
    vehicle_count: "",
    advance: "",
  });

  const toast = useToast();

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    fetchWagons();
  }, []);

  const fetchWagons = async () => {
    try {
      const res = await getAllWagons();
      setWagonData(res.data || []);
    } catch (err) {
      toast("Failed to fetch wagon", "ERROR");
    }
  };

  const handleAddClick = () => {
    setWagonForm({
      date: "",
      station: "",
      vehicle_count: "",
      advance: "",
    });

    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !wagonForm.date ||
      !wagonForm.station ||
      !wagonForm.vehicle_count ||
      !wagonForm.advance
    ) {
      toast("Please fill all fields", "ERROR");
      return;
    }

    try {
      if (wagonForm.id) {
        await updateWagon(wagonForm);
        toast("Wagon updated successfully");
      } else {
        await saveWagon(wagonForm);
        toast("Wagon added successfully");
      }

      await fetchWagons();
      handleCancel();
    } catch (err) {
      toast("Failed to save wagon", "ERROR");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setWagonForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEdit = (item) => {
    setWagonForm({
      id: item.id,
      date: item.date,
      station: item.station,
      vehicle_count: item.vehicle_count,
      advance: item.advance,
    });

    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      await deleteWagon(id);
      toast("Deleted successfully");
      await fetchWagons();
    } catch (err) {
      toast("Delete failed", "ERROR");
    }
  };

  const handleCancel = () => {
    setWagonForm({
      date: "",
      station: "",
      vehicle_count: "",
      advance: "",
    });

    setShowForm(false);
  };

  return (
    <div className="fixed-bottom-bar">
      <div className="osahan-trending">

        {/* Header */}
        <div className="bg-primary border-bottom p-3">
          <div className="d-flex align-items-center justify-content-between">
            <Link to="/" className="text-white font-weight-bold">
              <ChevronLeft /> Back
            </Link>

            <Link className="toggle">
              <span
                className="toggle"
                onClick={() => setShowSideBar(true)}
                style={{ cursor: "pointer" }}
              >
                <Menu size={30} color="white" />
              </span>
            </Link>
          </div>

          <h2 className="font-weight-bold pt-3 m-0 text-white">
            Wagon
          </h2>
        </div>

        {/* Add Button */}
        <div className="d-flex justify-content-end mt-3 px-3">
          <Button
            variant="secondary"
            size="sm"
            style={{
              outline: "none",
              border: "none",
            }}
            onClick={handleAddClick}
          >
            Add
          </Button>
        </div>

        {/* Wagon Form Modal */}
        <Modal
          visible={showForm}
          size="md"
          headerText={wagonForm.id ? "Edit Wagon" : "Add Wagon"}
          onClose={handleCancel}
        >
          <WagonForm
            wagonForm={wagonForm}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </Modal>

        {/* Wagon Cards */}
        <div className="most_popular p-3">
          <div className="row justify-content-center">

            {wagonData.length === 0 ? (
              <div className="text-center text-muted py-4">
                No wagon records found
              </div>
            ) : (
              wagonData.map((wagon) => (
                <div
                  className="col-12 d-flex justify-content-center mb-3"
                  key={wagon.id}
                >
                  <div
                    className="card shadow-sm bill-card border-0"
                    style={{ width: "100%" }}
                  >
                    <div className="card-body p-3">

                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h5 className="fw-bold text-muted mb-1">
                            {wagon.station}
                          </h5>

                          <small className="text-muted">
                            {wagon.date}
                          </small>
                        </div>

                        <div className="d-flex gap-2">
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleEdit(wagon)}
                          >
                            Edit
                          </Button>

                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDelete(wagon.id)}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>

                      <hr className="my-2" />

                      <div className="row text-center">

                        <div className="col-6">
                          <small className="text-muted">
                            Vehicle Count
                          </small>

                          <h6 className="fw-bold mt-1 mb-0">
                            {wagon.vehicle_count}
                          </h6>
                        </div>

                        <div className="col-6">
                          <small className="text-muted">
                            Advance
                          </small>

                          <h6 className="text-success fw-bold mt-1 mb-0">
                            ₹ {Number(wagon.advance).toFixed(2)}
                          </h6>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              ))
            )}

          </div>
        </div>

        {/* Sidebar */}
        <Sidebar
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          onLogout={handleLogout}
        />

        {/* Footer */}
        <div className="osahan-menu-fotter fixed-bottom bg-white px-3 py-2 text-center">
          <div className="row">

            <div className="col">
              <Link
                to="/vehicleAdvance"
                className="small font-weight-bold"
                style={{
                  color:
                    currentPath === "/vehicleAdvance"
                      ? "#004085"
                      : "#000",
                }}
              >
                <p className="h4 m-0">
                  <Target
                    color={
                      currentPath === "/vehicleAdvance"
                        ? "#004085"
                        : "#000"
                    }
                  />
                </p>
                Vehicle Advance
              </Link>
            </div>

            <div className="col">
              <Link
                to="/contractorPayment"
                className="small font-weight-bold"
                style={{
                  color:
                    currentPath === "/contractorPayment"
                      ? "#004085"
                      : "#000",
                }}
              >
                <p className="h4 m-0">
                  <Feather
                    color={
                      currentPath === "/contractorPayment"
                        ? "#004085"
                        : "#000"
                    }
                  />
                </p>
                Contractor
              </Link>
            </div>

            <div className="col bg-white rounded-circle mt-n4 px-3 py-2 d-flex justify-content-center align-items-center">
              <div
                className="rounded-circle shadow d-flex justify-content-center align-items-center"
                style={{
                  width: "68px",
                  height: "68px",
                  background:
                    "linear-gradient(90deg, rgb(1, 44, 104), rgb(63, 125, 141))",
                }}
              >
                <Link
                  to="/"
                  className="d-flex justify-content-center align-items-center"
                >
                  <Airplay size={32} color="white" />
                </Link>
              </div>
            </div>

            <div className="col">
              <Link
                to="/billView"
                className="small font-weight-bold"
                style={{
                  color:
                    currentPath === "/billView"
                      ? "#004085"
                      : "#000",
                }}
              >
                <p className="h4 m-0">
                  <Eye
                    color={
                      currentPath === "/billView"
                        ? "#004085"
                        : "#000"
                    }
                  />
                </p>
                Bills
              </Link>
            </div>

            <div className="col">
              <Link
                to="/billProcess"
                className="small font-weight-bold"
                style={{
                  color:
                    currentPath === "/billProcess"
                      ? "#004085"
                      : "#000",
                }}
              >
                <p className="h4 m-0">
                  <Play
                    color={
                      currentPath === "/billProcess"
                        ? "#004085"
                        : "#000"
                    }
                  />
                </p>
                Process
              </Link>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Wagon
